module.exports = __webpack_public_path__ + "static/media/icn_stories_big.18e85e57.svg";